var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdyFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 723,
    height: 723,
    viewBox: "0 0 723 723",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.04 231.882C664.533 563.132 115.328 730.225 23.7064 217.661C122.789 294.636 285.368 383 354.5 169.5C403 19.7182 655 37.5 655.04 231.882Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 216.5C23.5686 216.887 23.6374 217.274 23.7064 217.661M23.7064 217.661C115.328 730.225 664.533 563.132 655.04 231.882C655 37.5 403 19.7182 354.5 169.5C285.368 383 122.789 294.636 23.7064 217.661ZM23.7064 217.661C23.6376 217.607 23.5688 217.554 23.5 217.5M669.618 204.39L694.39 184.382M670.703 231.882L698.744 246.971M298.5 554.5V650.5M368.5 554.5V650.5",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 551.5,
    cy: 210.5,
    r: 12.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 42
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdyFill);
export default __webpack_public_path__ + "static/media/birdy-fill.64dec88193b47816923b4351afc42efa.svg";
export { ForwardRef as ReactComponent };